import Config from './config';
import Utils from './utils';
import Session from './session-util';
import SessionKeys from '../constants/SessionKeys';

const { cb } = window;
const iamBus = cb.core.iam.getEventBus();

const getTokens = () => {
  //scoping issue with ES6, cb must b declared in function scope
  const { cb: cbInner } = window;
  const { isLoggedIn, sessionId, basicProfile } = cbInner.core.iam.getAuthSession();
  const token = cbInner.core.iam.getJWTToken();
  let roleOrgsList = null;
  Session.setValue(SessionKeys.BASIC_PROFILE, basicProfile);

  if (token) {
    roleOrgsList = getRoleOrgList(token);
  }

  return {
    isLoggedIn,
    sessionId,
    roleOrgsList,
    token
  };
};

const getRoleOrgList = (token) => {
  let roleOrgsList = null;

  try {

    roleOrgsList = JSON.parse(atob(token.split('.')[1])).cb.ro;

  } catch (error) {
    console.log(`Token Parse FAILED: `, error);
  }

  return roleOrgsList
}

const logout = () => {
  console.log('debug logout');
  const logoutUrl = `${Config.urls.accountLogout.host}${Config.urls.accountLogout.param}`;
  const durl = `${Utils.getCurrentUrl()}${Config.urls.login}`;
  window.location.replace(`${logoutUrl}${durl}`);
};

const onLogout = () => {


  logoutRedirect();
};

const loginRedirect = ( page ) => {
  const {
    location: { pathname },
  } = window;

  if (pathname !== Config.urls[`${page}`]) {

    window.location = Config.urls[`${page}`];
  }
}

const logoutRedirect = () => {
  const {
    location: { pathname },
  } = window;
  Session.clearAll();
  if (pathname !== Config.urls.login) {
    window.location = Config.urls.login;
  }
}

//only solution so far is exporting this for every page
//setInterval forces re-occuring check on token until it returns true
const checkToken = () => {
  return new Promise( (resolve, reject) => {
    let count = 0;
    const timeOut = setInterval( () => {

      //5 sec timout
      if(count > 100){
        clearInterval(timeOut);
        reject(false);
      }

      const { token } = getTokens();

      if(token){
        clearInterval(timeOut);
        resolve({ token });
      }

      count++;

    }, 50 )
  });
};

//function as param, regist that as teh callback for the onAWSLogin
const init = ( onLoginCallback ) => {
  const { isLoggedIn } = getTokens();

  if (!isLoggedIn) {
    onLogout();
  }

  iamBus.on(cb.core.iam.events.Logout, onLogout);

  iamBus.on(cb.core.iam.events.AWSLogin, onLoginCallback);

  //third iambus event for the for the cb.core.iam.events.Login, publish isLogin:true
  //then on loginlayout, do not render login component if isLogin:true
  //solve that extra screen on login
};

export default {
  init,
  getTokens,
  checkToken,
  logout,
  logoutRedirect,
  loginRedirect
};
